import { de } from "zod/v4/locales/index.cjs";
import { coreApi } from "./coreApi";

const trialBalanceApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getTrialBalance: builder.query({
      query: (query) => `/accounting/reports/trial-balance?${query}`,
    }),
  }),
});

export const { useGetTrialBalanceQuery, useLazyGetTrialBalanceQuery } = trialBalanceApi;

export default trialBalanceApi;
